




































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import { mapGetters } from "vuex";
import { mixin as clickaway } from "vue-clickaway";
import { Trans } from "@/shared/scripts/helpers/translation/translation";
import iwTopNavigationItem from "./TopNavigationItem.vue";
import { logout } from "@/shared/scripts/Authenticate";
import { i18n } from "@/shared/scripts/helpers/translation/i18n";
import iwTooltip from "@/shared/components/Tooltip.vue";
import iwImmocode from "@/shared/components/Immocode.vue";
import iwLegacyBrowserBanner from "@/shared/components/LegacyBrowserBanner.vue";
import { setLayoutOffset } from "@/encoding/scripts/layout";

export default Vue.extend({
    components: {
        iwImmocode: iwImmocode,
        iwLegacyBrowserBanner: iwLegacyBrowserBanner,
        iwTopNavigationItem: iwTopNavigationItem,
        iwTooltip: iwTooltip
    },
    mixins: [clickaway],

    props: {
        cmsSlugs: {
            type: String,
            required: false,
            default: null
        }
    },

    data: function() {
        return {
            menuOpen: false as boolean,
            activeSubmenu: null as string | null,
            firstFocusableElement: null as unknown as HTMLElement,
            lastFocusableElement: null as unknown as HTMLElement,
            languages: Trans.supportedLocalesArray,
            languageListOpen: false as boolean,
            classifiedId: "" as string,
            myImmowebMenuOpen: false as boolean,
            isMobile: true as boolean,
            topNavigationIsFixed: false as boolean,
            documentScrollTop: 0 as number
        };
    },

    computed: {
        ...mapGetters({
            isLogged: "UserModule/isLogged",
            isMasquerading: "UserModule/isMasquerading"
        }),
        activeRoute: function(): string {
            return this.$route.name as string;
        },
        activeLanguage: function(): string {
            return Trans.currentLocale as string;
        },
        activeLanguageName: function(): string|undefined {
            for(let index = 0; index < this.languages.length; index++) {
                if(this.languages[index].label === this.activeLanguage) {
                    return this.languages[index].name as string;
                }
            }
        },
        pathUrl: function(): string {
            return `${process.env.VUE_APP_IMMOWEB_URL}/${this.activeLanguage}` as string;
        },
        myImmowebLabel: function(): string {
            return (this.isLogged) ? this.$t("my_immoweb") as string : this.$t("sign_in") as string;
        },
        profileLabel: function(): string  {
            switch(this.activeLanguage) {
            case "fr":
                return "profil";
            case "nl":
                return "profiel";
            default:
                return "profile";
            }
        },
        mySavedSearchesLink: function(): string {
            switch(this.activeLanguage) {
            case "fr":
                return `${this.pathUrl}/${this.profileLabel}/recherches-sauvegardees`;
            case "nl":
                return `${this.pathUrl}/${this.profileLabel}/bewaarde-zoekacties`;
            default:
                return `${this.pathUrl}/${this.profileLabel}/saved-searches`;
            }
        },
        mySavedPropertiesLink: function(): string {
            switch(this.activeLanguage) {
            case "fr":
                return `${this.pathUrl}/${this.profileLabel}/favoris`;
            case "nl":
                return `${this.pathUrl}/${this.profileLabel}/favoriet`;
            default:
                return `${this.pathUrl}/${this.profileLabel}/favorites`;
            }
        },
        myProfileLink: function(): string {
            switch(this.activeLanguage) {
            case "fr":
                return `${this.pathUrl}/${this.profileLabel}`;
            case "nl":
                return `${this.pathUrl}/${this.profileLabel}`;
            default:
                return `${this.pathUrl}/${this.profileLabel}`;
            }
        },
        mySubscriptionsLink: function(): string {
            switch(this.activeLanguage) {
            case "fr":
                return `${this.myProfileLink}/inscriptions`;
            case "nl":
                return `${this.myProfileLink}/inschrijving`;
            default:
                return `${this.myProfileLink}/subscriptions`;
            }
        },
        myImmowebLinks: function(): Array<Record<string, unknown>> {
            return [
                {
                    "label": this.$t("my_ads"),
                    "url": "#",
                    "route": "my-immoweb"
                },
                {
                    "label": this.$t("my_saved_searches"),
                    "url": this.mySavedSearchesLink,
                    "class": "top-navigation__dropdown__item--divider"
                },
                {
                    "label": this.$t("my_saved_properties"),
                    "url": this.mySavedPropertiesLink,
                },
                {
                    "label": this.$t("my_profile"),
                    "url": this.myProfileLink,
                    "class": "top-navigation__dropdown__item--divider"
                },
                {
                    "label": this.$t("my_subscriptions"),
                    "url": this.mySubscriptionsLink
                }
            ];
        },
        isLoginModalOpen: function(): boolean {
            return this.$store.getters["ModalModule/isModalOpen"];
        },
        windowScrollBarWidth: function(): number {
            return this.$store.getters["modalModule/windowScrollBarWidth"];
        },
        searchLabel: function(): string  {
            switch(this.activeLanguage) {
            case "fr":
                return "recherche";
            case "nl":
                return "zoeken";
            default:
                return "search";
            }
        },
        searchForSaleParameters: function(): string  {
            switch(this.activeLanguage) {
            case "fr":
                return "a-vendre?countries=BE";
            case "nl":
                return "te-koop?countries=BE";
            default:
                return "for-sale?countries=BE";
            }
        },
        searchForRentParameters: function(): string  {
            switch(this.activeLanguage) {
            case "fr":
                return "a-louer?countries=BE";
            case "nl":
                return "te-huur?countries=BE";
            default:
                return "for-rent?countries=BE";
            }
        },
        buyApartmentsLink:function(): string {
            switch(this.activeLanguage) {
            case "fr":
                return`${this.pathUrl}/${this.searchLabel}/appartement/${this.searchForSaleParameters}`;
            case "nl":
                return `${this.pathUrl}/${this.searchLabel}/appartement/${this.searchForSaleParameters}`;
            default:
                return `${this.pathUrl}/${this.searchLabel}/apartment/${this.searchForSaleParameters}`;
            }
        },
        buyHousesLink:function(): string {
            switch(this.activeLanguage) {
            case "fr":
                return `${this.pathUrl}/${this.searchLabel}/maison/${this.searchForSaleParameters}`;
            case "nl":
                return `${this.pathUrl}/${this.searchLabel}/huis/${this.searchForSaleParameters}`;
            default:
                return `${this.pathUrl}/${this.searchLabel}/house/${this.searchForSaleParameters}`;
            }
        },
        buyHouseAndApartmentLink: function(): string {
            switch(this.activeLanguage) {
            case "fr":
                return `${this.pathUrl}/${this.searchLabel}/maison-et-appartement/${this.searchForSaleParameters}`;
            case "nl":
                return `${this.pathUrl}/${this.searchLabel}/huis-en-appartement/${this.searchForSaleParameters}`;
            default:
                return `${this.pathUrl}/${this.searchLabel}/house-and-apartment/${this.searchForSaleParameters}`;
            }
        },
        buyNewlyBuiltApartmentLink: function(): string {
            switch(this.activeLanguage) {
            case "fr":
                return `${this.pathUrl}/${this.searchLabel}/projet-neuf-appartements/${this.searchForSaleParameters}`;
            case "nl":
                return `${this.pathUrl}/${this.searchLabel}/nieuwbouwproject-appartementen/${this.searchForSaleParameters}`;
            default:
                return `${this.pathUrl}/${this.searchLabel}/new-real-estate-project-apartments/${this.searchForSaleParameters}`;
            }
        },
        buyNewlyBuiltHouseLink: function(): string {
            switch(this.activeLanguage) {
            case "fr":
                return `${this.pathUrl}/${this.searchLabel}/projet-neuf-appartements/${this.searchForSaleParameters}`;
            case "nl":
                return `${this.pathUrl}/${this.searchLabel}/nieuwbouwproject-appartementen/${this.searchForSaleParameters}`;
            default:
                return `${this.pathUrl}/${this.searchLabel}/new-real-estate-project-apartments/${this.searchForSaleParameters}`;
            }
        },
        homesToBuildLink: function(): string {
            switch(this.activeLanguage) {
            case "fr":
                return `${this.pathUrl}/${this.searchLabel}/projet-neuf-appartements/${this.searchForSaleParameters}`;
            case "nl":
                return `${this.pathUrl}/${this.searchLabel}/nieuwbouwproject-appartementen/${this.searchForSaleParameters}`;
            default:
                return `${this.pathUrl}/${this.searchLabel}/new-real-estate-project-apartments/${this.searchForSaleParameters}`;
            }
        },
        advancedSearchLabel: function(): string {
            switch(this.activeLanguage) {
            case "fr":
                return "recherche-avancee";
            case "nl":
                return "geavanceerd-zoeken";
            default:
                return "advanced-search";
            }
        },
        advancedSearchForSaleParameters: function(): string  {
            return "transactionTypes=FOR_SALE&countries=BE";
        },
        advancedSearchForRentParameters: function(): string  {
            return "transactionTypes=FOR_Rent&countries=BE";
        },
        advancedSearchForSale: function(): string  {
            return `${this.advancedSearchLabel}?${this.advancedSearchForSaleParameters}`;
        },
        advancedSearchForRent: function(): string  {
            return `${this.advancedSearchLabel}?${this.advancedSearchForRentParameters}`;
        },
        buyOtherLink: function(): string {
            return `${this.pathUrl}/${this.advancedSearchForSale}`;
        },
        rentApartmentsLink: function() {
            switch(this.activeLanguage) {
            case "fr":
                return `${this.pathUrl}/${this.searchLabel}/appartement/${this.searchForRentParameters}`;
            case "nl":
                return `${this.pathUrl}/${this.searchLabel}/appartement/${this.searchForRentParameters}`;
            default:
                return `${this.pathUrl}/${this.searchLabel}/apartment/${this.searchForRentParameters}`;
            }
        },
        rentHousesLink: function(): string {
            switch(this.activeLanguage) {
            case "fr":
                return `${this.pathUrl}/${this.searchLabel}/maison/${this.searchForRentParameters}`;
            case "nl":
                return `${this.pathUrl}/${this.searchLabel}/huis/${this.searchForRentParameters}`;
            default:
                return `${this.pathUrl}/${this.searchLabel}/house/${this.searchForRentParameters}`;
            }
        },
        rentHousesAndApartmentsLink: function(): string {
            switch(this.activeLanguage) {
            case "fr":
                return `${this.pathUrl}/${this.searchLabel}/maison-et-appartement/${this.searchForRentParameters}`;
            case "nl":
                return `${this.pathUrl}/${this.searchLabel}/huis-en-appartement/${this.searchForRentParameters}`;
            default:
                return `${this.pathUrl}/${this.searchLabel}/house-and-apartment/${this.searchForRentParameters}`;
            }
        },
        rentStudentHousingLink: function(): string {
            return `${this.pathUrl}/${this.searchLabel}/kot/${this.searchForRentParameters}`;
        },
        rentBusinessLink: function(): string {
            switch(this.activeLanguage) {
            case "fr":
                return `${this.pathUrl}/${this.searchLabel}/commerce/${this.searchForRentParameters}`;
            case "nl":
                return `${this.pathUrl}/${this.searchLabel}/handelszaak/${this.searchForRentParameters}`;
            default:
                return `${this.pathUrl}/${this.searchLabel}/business/${this.searchForRentParameters}`;
            }
        },
        rentOtherLink: function(): string {
            return `${this.pathUrl}/${this.advancedSearchForRent}`;
        },
        buyAdvancedSearchLink: function(): string {
            return `${this.pathUrl}/${this.advancedSearchForSale}&propertyTypes=HOUSE`;
        },
        rentAdvancedSearchLink: function(): string {
            return `${this.pathUrl}/${this.advancedSearchForRent}&propertyTypes=HOUSE`;
        },
        buyMapLink: function(): string {
            switch(this.activeLanguage) {
            case "fr":
                return `${this.pathUrl}/carte?${this.advancedSearchForSaleParameters}`;
            default:
                return `${this.pathUrl}/map?${this.advancedSearchForSaleParameters}`;
            }
        },
        rentMapLink: function(): string {
            switch(this.activeLanguage) {
            case "fr":
                return `${this.pathUrl}/carte?${this.advancedSearchForRentParameters}`;
            default:
                return `${this.pathUrl}/map?${this.advancedSearchForRentParameters}`;
            }
        },
        buyVirtualLink: function(): string {
            switch(this.activeLanguage) {
            case "fr":
                return `${this.pathUrl}/${this.searchLabel}/maison/${this.searchForSaleParameters}&hasVirtualTourOr360=true`;
            case "nl":
                return `${this.pathUrl}/${this.searchLabel}/huis/${this.searchForSaleParameters}&hasVirtualTourOr360=true`;
            default:
                return `${this.pathUrl}/${this.searchLabel}/house/${this.searchForSaleParameters}&hasVirtualTourOr360=true`;
            }
        },
        rentVirtualLink: function(): string {
            switch(this.activeLanguage) {
            case "fr":
                return `${this.pathUrl}/${this.searchLabel}/maison/${this.searchForRentParameters}&hasVirtualTourOr360=true`;
            case "nl":
                return `${this.pathUrl}/${this.searchLabel}/huis/${this.searchForRentParameters}&hasVirtualTourOr360=true`;
            default:
                return `${this.pathUrl}/${this.searchLabel}/house/${this.searchForRentParameters}&hasVirtualTourOr360=true`;
            }
        },
        mortgageURL: function(): string {
            switch(this.activeLanguage) {
            case "fr":
                return `${this.pathUrl}/demande-de-credit/propriete?icid_to=mortgage&icid_cta=menu`;
            case "nl":
                return `${this.pathUrl}/kredietaanvraag/pand?icid_to=mortgage&icid_cta=menu`;
            default:
                return `${this.pathUrl}/credit-application/property?icid_to=mortgage&icid_cta=menu`;
            }
        },
        insurancesURL: function() {
            switch(this.activeLanguage) {
            case "fr": return "https://protect.immoweb.be/fr?utm_source=website&utm_medium=referral&utm_campaign=menu";
            case "en": return "https://protect.immoweb.be/?utm_source=website&utm_medium=referral&utm_campaign=menu";
            case "nl": return "https://protect.immoweb.be/nl?utm_source=website&utm_medium=referral&utm_campaign=menu";
            }
        },
        immoreviewURL: function(): string {
            switch(this.activeLanguage) {
            case "fr":
                return "https://www.immoreviews.be/fr?utm_source=website&utm_medium=referral&utm_campaign=menu";
            case "nl":
                return "https://www.immoreviews.be/nl?utm_source=website&utm_medium=referral&utm_campaign=menu";
            default:
                return "https://www.immoreviews.be/";
            }
        },
        immowebBlogUrl: function() {
            switch(this.activeLanguage) {
            case "fr":
                return "https://blog.immoweb.be/fr?utm_source=website&utm_medium=referral&utm_campaign=menu";
            case "nl":
                return "https://blog.immoweb.be/nl?utm_source=website&utm_medium=referral&utm_campaign=menu";
            default:
                return "https://blog.immoweb.be/fr?utm_source=website&utm_medium=referral&utm_campaign=menu";
            }
        },
        estimateMyPropertyValuateAndSellURL: function(): string {
            switch(this.activeLanguage) {
            case "fr":
                return "https://estimation.immoweb.be/estimation-immobiliere/seg1?utm_source=immoweb&utm_medium=referral&utm_campaign=self-promo-valuation&utm_content=valuation-link";
            case "nl":
                return "https://schatting.immoweb.be/real-schatting/seg1?utm_source=immoweb&utm_medium=referral&utm_campaign=self-promo-valuation&utm_content=valuation-link";
            default:
                return "https://valuation.immoweb.be/real-estate-estimate/seg1?utm_source=immoweb&utm_medium=referral&utm_campaign=self-promo-valuation&utm_content=valuation-link";
            }
        },
        agencySearchResultsURL: function(): string {
            switch(this.activeLanguage) {
            case "fr":
                return `${this.pathUrl}/agences`;
            case "nl":
                return `${this.pathUrl}/agentschappen`;
            default:
                return `${this.pathUrl}/agencies`;
            }
        },
        notarySearchResultsURL: function(): string {
            switch(this.activeLanguage) {
            case "fr":
                return `${this.pathUrl}/notaires`;
            case "nl":
                return `${this.pathUrl}/notarissen`;
            default:
                return `${this.pathUrl}/notaries`;
            }
        },
        propertyBuilderSearchResultsURL: function(): string {
            switch(this.activeLanguage) {
            case "fr":
                return `${this.pathUrl}/promoteur-immobilier`;
            case "nl":
                return `${this.pathUrl}/vastgoedontwikkelaars`;
            default:
                return `${this.pathUrl}/property-developers`;
            }
        },
        placeAnAdUrl: function() {
            let classifiedsDirectory = "/classifieds#/";
            switch(this.activeLanguage) {
            case "fr":
                return `${classifiedsDirectory}fr/encodage/bienvenue`;
            case "en":
                return `${classifiedsDirectory}en/encoding/welcome`;
            case "nl":
                return `${classifiedsDirectory}nl/coderen/welkom`;
            }
        },
        isSuccessMessage: function(): boolean {
            return this.$store.getters["alertMessageModule/isSuccessMessage"];
        },
        displayLoginBtn: function(): boolean {
            return process.env.VUE_APP_IMMOWEB_BUTTON_LOGIN !== "false";
        },
        displayPlaceAnAdBtn: function(): boolean {
            return process.env.VUE_APP_IMMOWEB_BUTTON_PLACE_AN_AD !== "false";
        },
        realEstatePriceMapURL: function(): string {
            return `${process.env.VUE_APP_IMMOWEB_PRICE_MAP_URL}/${this.activeLanguage}?utm_source=website&utm_medium=referral&utm_campaign=pricemap-autopromo-static&utm_content=menu`;
        },
    },
    watch: {
        isLoginModalOpen: function(newValue:boolean) {
            if (newValue === true) {
                this.handleModalOpen();
            } else {
                this.handleModalClose();
            }
        },
    },
    updated: function() {
        this.getFocusableElement();
    },
    mounted: function() {
        // Responsive Behavior
        /* istanbul ignore next */
        this.$responsive.registerMediaQuery("from-desktop", () => {
            if (this.menuOpen === true) {
                this.closeMenu();
            }

            this.isMobile = false;

            this.configureDesktopMenu();
        }, () => {
            if (this.menuOpen === true) {
                this.closeMenu();
            }

            this.isMobile = true;

            this.configureMobileMenu();
        });
    },

    methods: {
        logout: function () {
            logout().then(() => {
                window.location.href = this.pathUrl;
            }).catch(error => {
                let label = i18n.t("server_not_responding_error") as string;
                this.dialog.alert(label);
                console.error(error);
            });
        },
        encodingFunnelRoute: function(route:string) {
            // To avoid duplicated navigation
            if(this.$router.currentRoute.name !== null && this.$router.currentRoute.name !== route) {
                let urlTranslated = this.$t(route) as string;
                const to = this.$router.resolve({path: urlTranslated});
                this.$router.push(to.location);
            }
            this.closeMenuEncodingLinks();
        },
        toggleMenu: function() {
            if (this.menuOpen === true) {
                this.closeMenu();
            } else {
                this.openMenu();
            }
        },
        openMenu: function() {
            this.menuOpen = true;

            // Save current page scroll position
            let documentElement = (
                document.scrollingElement ||
                document.documentElement ||
                document.body.parentNode ||
                document.body
            ) as HTMLElement;

            this.documentScrollTop = documentElement.scrollTop;

            // Add a JS Menu Open on html tag (disable scroll in css)
            document.documentElement.classList.add("js-fullscreen");
            document.documentElement.classList.add("mobile-navigation-open");
        },
        closeMenu: function() {
            this.menuOpen = false;
            // Remove JS Menu Open class on html tag
            document.documentElement.classList.remove("js-fullscreen");
            document.documentElement.classList.remove("mobile-navigation-open");

            // Set scroll position back to is position before menu opening
            window.scroll(0, this.documentScrollTop);

            this.closeAllSubmenu();

            Vue.nextTick(() => {
                setLayoutOffset(this.isMobile, this.isMasquerading);
            });
        },
        initiateClassified:function(){
            this.$store.commit("MyClassifiedsModule/setMyClassifiedSelected", undefined);
        },
        closeMenuEncodingLinks:function() {
            if(this.isMobile) {
                this.closeMenu();
            } else {
                this.closeMyImmowebMenu();
            }
        },
        toggleSubmenu: function(value: string | null) {
            // Save current submenu (null: no submenu opened, string: name of the submenu)
            this.activeSubmenu = value;

            // Get all submenu except the current one
            let submenuToClose = this.$children.filter((submenu: Vue) => {
                if(submenu !== null && submenu.$el.className === "top-navigation__menu__item") {
                    if(submenu.name !== value) {
                        return submenu;
                    }
                }
            });

            // Close all children except the current one
            submenuToClose.forEach(function(submenu: Vue) {
                (submenu as Vue & { closeItem: (emit:boolean) => void }).closeItem(false);
            });
        },
        closeAllSubmenu: function() {
            if (this.activeSubmenu !== null) {
                this.$children.forEach(function(submenu: Vue) {
                    if(submenu !== null && submenu.$el.className === "top-navigation__menu__item") {
                        (submenu as Vue & { closeItem: () => void }).closeItem();
                    }
                });
            }
        },
        getFocusableElement: function() {
            // Get all focusable elements of the modal
            let focusableElements = [
                ...this.$el.querySelectorAll(
                    "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex=\"0\"]"
                )
            ] as Array<HTMLElement>;

            let focusableVisibleElements = focusableElements.filter((element: HTMLElement) => {
                if(element.offsetHeight) {
                    return element;
                }
            });

            this.firstFocusableElement = focusableVisibleElements[0];
            focusableVisibleElements.pop();
            this.lastFocusableElement = focusableVisibleElements[focusableVisibleElements.length-1];
        },
        handleTabPress: function(event: MouseEvent) {
            // If menu is open, lock focus inside it
            if (this.menuOpen) {
                if (event.shiftKey === true) {
                    //Tab backward
                    if (document.activeElement === this.firstFocusableElement) {
                        event.preventDefault();
                        this.lastFocusableElement.focus();
                    }
                } else {
                    // Tab forward
                    if (document.activeElement === this.lastFocusableElement) {
                        event.preventDefault();
                        this.firstFocusableElement.focus();
                    }
                }
            }
        },
        toggleLanguageList: function() {
            if (this.languageListOpen === true) {
                this.closeLanguageList();
            } else {
                this.openLanguageList();
            }
        },
        openLanguageList: function() {
            this.languageListOpen = true;
        },
        closeLanguageList: function() {
            this.languageListOpen = false;
        },
        switchLocale: function(locale: string) {
            if(this.$i18n.locale !== locale) {
                return Trans.changeLocale(locale).then(() => {
                    this.routeToPage(this.$router.currentRoute.name as string);
                    this.closeLanguageList();
                });
            }
        },
        handleModalOpen: function() {
            // Add padding right to the topNavigation to avoid content shifting to the right when scrollbar disappear (on a modal opening)
            let element = this.$el as HTMLElement;
            element.style.paddingRight = this.windowScrollBarWidth + "px";

        },
        handleModalClose: function() {
            // Reset the padding (on a modal close)
            let element = this.$el as HTMLElement;
            element.style.paddingRight = "0px";
        },
        toggleMyImmowebMenu: function(event?: Event) {
            event?.preventDefault();
            this.closeAllSubmenu();
            if (this.myImmowebMenuOpen === true) {
                this.closeMyImmowebMenu();
            } else {
                this.openMyImmowebMenu();
            }
        },
        closeMyImmowebMenu: function() {
            this.myImmowebMenuOpen = false;
        },
        openMyImmowebMenu: function() {
            this.myImmowebMenuOpen = true;
        },
        openLoginModal: function() {
            this.$store.commit("ModalModule/openLoginModal");
        },
        configureDesktopMenu: function() {
            Vue.nextTick(() => {
                const topNavigationSectionSupport = document.getElementById("topNavigationSectionSupport") as HTMLElement;
                const topNavigationLanguageMenu = document.getElementById("topNavigationLanguageMenu") as HTMLElement;

                if (topNavigationSectionSupport !== null) {
                    topNavigationSectionSupport.appendChild(topNavigationLanguageMenu);
                }
            });
        },
        configureMobileMenu: function() {
            Vue.nextTick(() => {
                const myImmowebMenuMobileWrapper = document.getElementById("myImmowebMenuMobileWrapper") as HTMLElement;
                const topNavigationLanguageMenu = document.getElementById("topNavigationLanguageMenu") as HTMLElement;

                if (myImmowebMenuMobileWrapper !== null) {
                    myImmowebMenuMobileWrapper.appendChild(topNavigationLanguageMenu);
                }
            });
        },
        openMenuAndSubmenu: function(submenuName: string, event?: Event) {
            event?.preventDefault();
            if (!this.menuOpen) {
                this.openMenu();
            }
            this.activeSubmenu = submenuName;

            // Find the specific navigation item component and trigger its opening
            this.$nextTick(() => {
                const targetComponent = this.$children.find(child => child.name === submenuName);
                if (targetComponent) {
                    (targetComponent as Vue & { openItem: () => void }).openItem();
                }
            });
        },
        handleTopNavigationScroll: function() {
            let documentElement = (
                document.scrollingElement ||
                document.documentElement ||
                document.body.parentNode ||
                document.body
            ) as HTMLElement;

            let documentScrollTop = 0;
            if(documentElement) {
                documentScrollTop = documentElement.scrollTop;
            }

            // Top Navigation
            if( !this.isMasquerading ||
                (this.isMasquerading && (this.activeRoute === "my-immoweb" || this.activeRoute === "route-welcome")) ||
                (this.isMobile && this.isMasquerading && this.activeRoute !== "my-immoweb" && this.activeRoute !== "route-welcome")) {
                let topNavigation = document.getElementById("top-navigation");
                if(topNavigation) {
                    this.topNavigationIsFixed = (documentScrollTop > 1);
                }
            }

            if(this.isMobile && !this.isMasquerading && this.activeRoute !== "my-immoweb" && this.activeRoute !== "route-welcome" && this.activeRoute !== "add-modify-pictures") {
                this.topNavigationIsFixed = false;
            }
        }
    }
});
